import { BOOK_CHAPTERS_SORTED } from "redux/types";
import bookChaptersUpdated from "./bookChaptersUpdated";


export default function bookChapterSort(osbn, orderedKeys) {
    return async (dispatch, getState) => {

        const { chapters } = getState().books.books[osbn];
        const sortedChapters = {};

        // Reorder chapters based on the new order from react-movable
        orderedKeys.forEach((chapterId) => {
            sortedChapters[chapterId] = chapters[chapterId];
        });

        // Dispatch Redux update
        dispatch({
            type: BOOK_CHAPTERS_SORTED,
            osbn,
            chapters: sortedChapters,
        });

        // Trigger DB save/update if needed
        dispatch(bookChaptersUpdated(osbn));
    };
}